/** @format */
import { Taxonomy } from '@toucan/common/services/taxonomy/config/types';

import { client } from '@toucan/client/global/axios';

export async function getCategoryTree(): Promise<Taxonomy> {
    const response = await client.get('/taxonomy/category');
    return response.data;
}

export async function getBrandTree(): Promise<Taxonomy> {
    const response = await client.get('/taxonomy/brand');
    return response.data;
}
